import React, { PropTypes } from 'react';
import moment from 'moment';

class ColorBar extends React.Component {

    constructor(props) {
        super(props);
        this.state = {

        };
    }

    style = {
        // blue = "#0000FF", cornflowerblue = "#6495ed", cyan = "#00FFFF", green = "#008000", yellow="#FFFF00",orange="#FFA500",red="#FF0000"
        blue: { backgroundColor: "#0000FF", width: "7px", height: "35px" },
        red: { backgroundColor: "#FF0000", width: "7px", height: "35px" },
        cornflowerblue: { backgroundColor: "#6495ed", width: "7px", height: "35px" },
        cyan: { backgroundColor: "#00FFFF", width: "7px", height: "35px" },
        green: { backgroundColor: "#008000", width: "7px", height: "35px" },
        yellow: { backgroundColor: "#FFFF00", width: "7px", height: "35px" },
        orange: { backgroundColor: "#FFA500", width: "7px", height: "35px" },
    }

    calcLegend(N, parameter) {
        let C = this.props.range.R1; // 1
        let D = this.props.range.R7; // 7
        // let value  = A + ((B-A)*(N-C))/(D-C)
        if (parameter === "Date & Time") {
            //getting epoch value from (normalized value N as Range), A = initialDate, B = finalDate, range(C=1, D=7), 
            let initDate = new Date(moment(this.props.filters.date_from).format('ddd, DD MMMM YYYY HH:00:00')).getTime();
            let finalDate = new Date(moment(this.props.filters.date_to).format('ddd, DD MMMM YYYY HH:00:00')).getTime();
            return moment(moment(initDate + ((finalDate - initDate) * (N - C)) / (D - C)).format("YYYYMMDD:HH"), "YYYYMMDD:HH").fromNow()
        }
        if (!isNaN(parameter)) {
            let A = this.props.minValue;
            let B = this.props.maxValue;
            if (A === B && N === D) return (Math.round(A * 100) / 100).toFixed(2);
            else if (A === B && N !== D) return '';
            else return (Math.round((A + ((B - A) * (N - C)) / (D - C)) * 100) / 100).toFixed(2)
        }
    }

    renderColorBar = () => {
        const { range, parameter } = this.props;
        let Legend = parameter ?
            parameter === "Date & Time" ?
                {
                    R1: this.calcLegend(range.R1, parameter), R2: this.calcLegend(range.R2, parameter),
                    R3: this.calcLegend(range.R3, parameter), R4: this.calcLegend(range.R4, parameter),
                    R5: this.calcLegend(range.R5, parameter), R6: this.calcLegend(range.R6, parameter),
                    R7: this.calcLegend(range.R7, parameter)
                } :
                !isNaN(parameter) ?
                    {
                        R1: this.calcLegend(range.R1, parameter), R2: this.calcLegend(range.R2, parameter),
                        R3: this.calcLegend(range.R3, parameter), R4: this.calcLegend(range.R4, parameter),
                        R5: this.calcLegend(range.R5, parameter), R6: this.calcLegend(range.R6, parameter),
                        R7: this.calcLegend(range.R7, parameter)
                    }
                    : range
            : '';

        return (
            <div>
                <style>{`table,th,td{border:1px solid white;},td{vertical-align:bottom}`}</style>
                {this.props.parameter && this.props.parameter !== '' && this.props.render ?
                    <div style={{ display: "flex", flexDirection: "column", height: "60vh" }}>
                        <table >
                            <tbody>
                                <tr>
                                    <td style={this.style.red}></td>
                                    <td> <pre>{Legend.R7}</pre></td>
                                </tr>
                                <tr>
                                    <td style={this.style.orange}></td>
                                    <td><pre>{Legend.R6}</pre></td>
                                </tr>
                                <tr>
                                    <td style={this.style.yellow}></td>
                                    <td><pre>{Legend.R5}</pre></td>
                                </tr>
                                <tr>
                                    <td style={this.style.green}></td>
                                    <td><pre>{Legend.R4}</pre></td>
                                </tr>
                                <tr>
                                    <td style={this.style.cyan}></td>
                                    <td><pre>{Legend.R3}</pre></td>
                                </tr>
                                <tr>
                                    <td style={this.style.cornflowerblue}></td>
                                    <td><pre>{Legend.R2}</pre></td>
                                </tr>
                                <tr>
                                    <td style={this.style.blue}></td>
                                    <td><pre>{Legend.R1}</pre></td>
                                </tr>
                            </tbody>
                        </table>
                        {/* {this.props.parameter && this.props.parameter === "Date & Time" ?
                            < div >
                                <h6>max: {this.props.maxValue}</h6>
                                <h6>min: {this.props.minValue}</h6>
                            </div> : ''
                        } */}
                    </div >
                    : ''
                }
            </div>
        )
    }


    render() {
        const { classes } = this.props;
        const { selectedDate, selectedPeriod } = this.state;
        return (
            <div style={{ marginLeft: "5px" }} >
                {this.renderColorBar()}
            </div>
        )
    }
}
export default ColorBar;



// WEBPACK FOOTER //
// ./src/components/Station/Location/StationLocationMap2ColorBar.js